// Static footer links data for the application footer
export const STATIC_FOOTER_LINKS = [
    {
        "audit": {
            "dateCreated": "2021-04-22T13:21:00.972Z",
            "createdBy": "59e1966c756b443bb5c5d06635ee99ee"
        },
        "name": "Terms of Use",
        "description": "Terms of Use for active hub",
        "launchUrl": "https://loginstatic.pearson.com/html/PearsonEULA.html?",
        "launchType": " ",
        "footerlinkId": "urn:pearson:gps:footerlink:0cd3ea4f-c269-44f1-bd9b-f9a89bd04686"
    },
    {
        "audit": {
            "dateCreated": "2021-04-22T13:21:39.921Z",
            "createdBy": "59e1966c756b443bb5c5d06635ee99ee"
        },
        "name": "Terms and Conditions",
        "description": "Terms and Conditions for active hub",
        "launchUrl": "https://www.pearsonschoolsandfecolleges.co.uk/help/activehub-terms-conditions",
        "launchType": " ",
        "footerlinkId": "urn:pearson:gps:footerlink:95ceb35b-e716-4d9b-94cb-cc01a86f75ed"
    },
    {
        "audit": {
            "dateCreated": "2021-04-22T13:22:06.719Z",
            "createdBy": "59e1966c756b443bb5c5d06635ee99ee"
        },
        "name": "Privacy Notice",
        "description": "Privacy Notice for active hub",
        "launchUrl": "https://loginstatic.pearson.com/html/PearsonPrivacyPolicy.html?",
        "launchType": " ",
        "footerlinkId": "urn:pearson:gps:footerlink:53a3140f-0e30-4094-9a1c-b9f53d55f6b3"
    },
    {
        "audit": {
            "dateCreated": "2021-04-22T13:22:43.981Z",
            "createdBy": "59e1966c756b443bb5c5d06635ee99ee"
        },
        "name": "Cookie Policy",
        "description": "Cookie Policy for active hub",
        "launchUrl": "https://www.pearson.com/uk/pearson-privacy-and-you/cookie-policy.html",
        "launchType": " ",
        "footerlinkId": "urn:pearson:gps:footerlink:ebb4004d-108d-42b8-9eb0-b4effab643f8"
    },
    {
        "audit": {
            "dateCreated": "2021-04-22T13:23:23.595Z",
            "createdBy": "59e1966c756b443bb5c5d06635ee99ee"
        },
        "name": "Accessibility",
        "description": "Accessibility",
        "launchUrl": "https://www.pearson.com/uk/accessibility.html",
        "launchType": " ",
        "footerlinkId": "urn:pearson:gps:footerlink:397d9f72-eeed-4152-a6e1-49f265aef5ef"
    },
    {
        "audit": {
            "dateCreated": "2021-04-22T13:23:48.031Z",
            "createdBy": "59e1966c756b443bb5c5d06635ee99ee"
        },
        "name": "Contact Us",
        "description": "Contact Us",
        "launchUrl": "https://support.pearson.com/uk/s/digital-contactus",
        "launchType": " ",
        "footerlinkId": "urn:pearson:gps:footerlink:d96b5207-db0b-4e8a-97a1-af145fb9ac4b"
    }
];